{
  "allApps": "Toutes les applications",
  "back": "Retour à la page principale",
  "myApps": "Mes applications",
  "viewMoreApps": "Vue d’autres applications"
}
